import { render, staticRenderFns } from "./IntroductionToMortgageWatch.vue?vue&type=template&id=1c9a15fa&"
import script from "./IntroductionToMortgageWatch.vue?vue&type=script&lang=js&"
export * from "./IntroductionToMortgageWatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports